import style from "./style.module.scss"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { clx } from "../../../helpers/components"
import { Text } from "../../ui/Text"
// import "./style.scss"
import { redirectToSecure } from "../../../helpers/func"
import { DownloadPDF } from "../../pages/generalConditions"
import { useEffect } from "react"

const FooterLink = ({
    icon,
    title,
    onClick,
    href = "",
    target = '_self',
    ariaLabel = "link",
    disabled = false
}) => {
    if (disabled) {
        return (
            <Text className={clx(style._footer_link)}>
                {icon && <span className="_footer_link_icon">{icon}</span>}
                {title && <span className="_footer_link_title">{title}</span>}
            </Text>
        )
    }
    return (
        <Link to={onClick || href.includes("http") ? "#" : href} aria-label={ariaLabel} onClick={(e) => {

            if (onClick) {
                onClick(e)
            }
            if (href.includes("http")) {
                e.preventDefault()
                window.open(href, target)
            }
        }}>
            <Text className={clx(style._footer_link)}>
                {icon && <span className="_footer_link_icon">{icon}</span>}
                {title && <span className="_footer_link_title">{title}</span>}
            </Text>
        </Link>
    )
}
// div className={`_footer_section ${className ?? ""}`}
const FooterSection = ({
    title,
    children,
    className
}) => {
    return (
        <div className={[clx(style._footer_section), `${className ?? ""}`]}>
            {title && <Text variant="h5">{title}</Text>}
            {children && <div>
                {children}
            </div>}
        </div>
    )
}

const currentYear = new Date().getFullYear();


export const Footer = ({ radius = false }) => {
    const { t, i18n } = useTranslation("translations")


    const downloadButtonStyle = {
        backgroundColor: 'transparent',
        // color: '#000',
        // border: 'none',
        // borderRadius: '8px',
        // padding: '7px 20px',
        cursor: 'pointer',
        fontFamily: 'Typold Light',
        fontSize: '13px',
        // transition: 'background-color 0.3s ease'
        color: "#fff",
        border: 'none'
        
    };


    return (
        <div className={clx(style._footer, style._footer_gradient_colored, radius && style.rounded)} id="footerCustom">
            <div className={style.flex}>
                <div className={clx(style.container, style._footer_links)}>
                    <div className="">
                        <div className={clx(style._footer_section)}>
                            <div style={{width:'100%', height: '100%'}}>
                                <img src="/images/logo_white.png" className={clx(style._logo)} alt="Logo" width='50%' height='80%'/>
                            </div>
                            <FooterSection className={clx("ml-0", style.contact_section)} title={t("home-page.footer.contact-us-section.title")}>
                                <br />
                                <div className={clx(style.btsl)}>
                                    <div>
                                        <a href="tel:+229 91 92 04 47" className={clx(style.footerSp)}><span className={clx(style._icon, style._icon_rounded)}>
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.80868 1.72969C2.86519 1.67318 2.89345 1.64492 2.91835 1.62204C3.53047 1.05958 4.47136 1.05958 5.08349 1.62204C5.10838 1.64492 5.13664 1.67318 5.19316 1.72969L6.35971 2.89625C7.00135 3.53789 7.18486 4.50688 6.82227 5.33871C6.45968 6.17054 6.64319 7.13953 7.28483 7.78117L9.20228 9.69862C9.84392 10.3403 10.8129 10.5238 11.6447 10.1612C12.4766 9.79859 13.4456 9.9821 14.0872 10.6237L15.2538 11.7903C15.3103 11.8468 15.3385 11.8751 15.3614 11.9C15.9239 12.5121 15.9239 13.453 15.3614 14.0651C15.3385 14.09 15.3103 14.1183 15.2538 14.1748L14.5447 14.8838C13.9672 15.4613 13.1348 15.7037 12.3377 15.5265C6.90598 14.3195 2.66395 10.0775 1.45691 4.6458C1.27977 3.84863 1.52217 3.0162 2.0996 2.43877L2.80868 1.72969Z" stroke="white" strokeWidth="1.5" />
                                            </svg>
                                            </span> +229 91 92 04 47
                                        </a>
                                    </div>
                                    <div>
                                        <br />
                                        <a href="mailto:info@izichange.com" className={clx(style.footerSp)}>
                                            <span>
                                                <span className={clx(style._icon)}>

                                                    <svg width="20" height="20" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M19.9551 0.152281C18.5494 -1.78814e-05 16.7776 -9.88738e-06 14.5172 1.62876e-07H11.9443C9.68396 -9.88738e-06 7.91214 -1.78814e-05 6.50643 0.152281C5.07192 0.3077 3.90961 0.630553 2.91721 1.35157C2.31642 1.78807 1.78807 2.31642 1.35157 2.91721C1.15258 3.1911 0.982168 3.48038 0.836764 3.78827C0.391488 4.73113 0.192874 5.82445 0.0960796 7.12822C-5.54782e-06 8.42244 -2.99159e-06 10.0089 1.62876e-07 11.965V12.0557C-9.88738e-06 14.316 -1.78814e-05 16.0879 0.152281 17.4936C0.3077 18.9281 0.630553 20.0904 1.35157 21.0828C1.78807 21.6836 2.31642 22.2119 2.91721 22.6484C3.90961 23.3694 5.07192 23.6923 6.50643 23.8477C7.91211 24 9.68389 24 11.9442 24H14.5173C16.7776 24 18.5494 24 19.9551 23.8477C21.3896 23.6923 22.5519 23.3694 23.5443 22.6484C24.1451 22.2119 24.6735 21.6836 25.11 21.0828C25.831 20.0904 26.1538 18.9281 26.3093 17.4936C26.4616 16.0879 26.4615 14.3161 26.4615 12.0558V11.9642C26.4615 9.99474 26.4615 8.39982 26.3634 7.10036C26.2644 5.79084 26.0613 4.69389 25.6057 3.74826C25.4645 3.45519 25.3003 3.17912 25.11 2.91721C24.6735 2.31642 24.1451 1.78807 23.5443 1.35157C22.5519 0.630553 21.3896 0.3077 19.9551 0.152281ZM4.00235 2.84514C4.62759 2.39088 5.42786 2.12609 6.70529 1.98769C7.99999 1.84742 9.67191 1.84615 12 1.84615H14.4615C16.7896 1.84615 18.4615 1.84742 19.7563 1.98769C21.0337 2.12609 21.8339 2.39088 22.4592 2.84514C22.903 3.16762 23.2934 3.55792 23.6159 4.00172L21.2809 6.33675C19.2112 8.40648 17.7231 9.89173 16.4397 10.871C15.1775 11.834 14.2223 12.2202 13.2308 12.2202C12.2392 12.2202 11.284 11.834 10.0218 10.871C8.73839 9.89173 7.25036 8.40648 5.18063 6.33674L2.84561 4.00172C3.16815 3.55792 3.5585 3.16762 4.00235 2.84514ZM24.3536 5.87492C24.4279 6.26905 24.4831 6.71866 24.5225 7.23944C24.6148 8.46145 24.6154 9.98748 24.6154 12C24.6154 14.3281 24.6141 16 24.4738 17.2947C24.3354 18.5721 24.0707 19.3724 23.6164 19.9976C23.2938 20.4417 22.9032 20.8322 22.4592 21.1549C21.8339 21.6091 21.0337 21.8739 19.7563 22.0123C18.4615 22.1526 16.7896 22.1538 14.4615 22.1538H12C9.67191 22.1538 7.99999 22.1526 6.70529 22.0123C5.42786 21.8739 4.62759 21.6091 4.00235 21.1549C3.55829 20.8322 3.16777 20.4417 2.84514 19.9976C2.39088 19.3724 2.12609 18.5721 1.98769 17.2947C1.84742 16 1.84615 14.3281 1.84615 12C1.84615 10.0018 1.84673 8.483 1.93717 7.26491C1.97663 6.73335 2.03238 6.27551 2.10795 5.87492L3.92513 7.6921C5.93408 9.70107 7.50846 11.2755 8.90201 12.3387C10.3284 13.427 11.6733 14.0664 13.2308 14.0664C14.7882 14.0664 16.1332 13.427 17.5595 12.3387C18.9531 11.2755 20.5274 9.70109 22.5364 7.69213L24.3536 5.87492Z" fill="white" />
                                                    </svg>
                                                </span>
                                            </span> 
                                            <span>info@izichange.com</span>
                                        </a>
                                    </div>
                                </div>

                                

                            </FooterSection>
                        </div>
                        
                    </div>
                    <div>
                        <FooterSection title={t("home-page.footer.about-us-section.title")}>
                            <FooterLink title={t("home-page.footer.about-us-section.link-1")} href="/a-propos" ariaLabel="/a-propos" />
                            <FooterLink title={t("home-page.footer.about-us-section.link-2")} href="/ambassadors" ariaLabel="/ambassadors"/>
                            <FooterLink title={t("home-page.footer.about-us-section.link-4")} href="/cafe_crypto" ariaLabel="/cafe_crypto"/>
                            <FooterLink title={t("home-page.footer.about-us-section.link-3")} href="/faq" ariaLabel="/faq"/>
                            <FooterLink title={t('politique-conf.download')} href="https://app.termly.io/dsar/991e198e-097b-4d6a-97d3-4301240a5356" target="_blank" ariaLabel="https://app.termly.io/dsar/991e198e-097b-4d6a-97d3-4301240a5356"/> 
                            <div className={clx(style.btsl)}></div>
                        </FooterSection>

                    </div>
                    <div>
                        <FooterSection title={t("home-page.footer.tuto-section.title")} >
                            <FooterLink title={t("home-page.footer.tuto-section.link-1")} disabled />
                            <FooterLink title={t("home-page.footer.tuto-section.link-2")} disabled />
                            <FooterLink title={t("home-page.footer.tuto-section.link-4")} disabled />
                        </FooterSection>
                    </div>
                    <div>
                        <FooterSection title={t("home-page.footer.service-section.title")} className="mr-0">
                            <FooterLink title={t("home-page.footer.service-section.achat-vente")} href="https://www.izichange.com/" target="_blank" ariaLabel="https://www.izichange.com/" />
                            <FooterLink title={t("home-page.footer.service-section.link-3")} ariaLabel="dashboard/pu_binace_direct" onClick={(e) => {
                                e.preventDefault()
                                redirectToSecure("dashboard/pu_binace_direct", i18n.language, true, false)
                            }} />
                            <FooterLink title={t("home-page.footer.service-section.link-4")} ariaLabel="dashboard/pu_latoken_client" onClick={(e) => {
                                e.preventDefault()
                                redirectToSecure("dashboard/pu_latoken_client", i18n.language, true, false)
                            }} />
                            <FooterLink title={t("home-page.footer.service-section.wallet-izichange")} href="https://www.izichange.com/" target="_blank" ariaLabel="https://www.izichange.com/" />
                            <FooterLink title={t("home-page.footer.service-section.virtual-card")} href="https://www.izichange.com/" target="_blank" ariaLabel="https://www.izichange.com/" />
                        </FooterSection>
                    </div>
                    <div>
                        <FooterSection title={t("home-page.footer.legal-section.title")} >
                            <FooterLink title={t("home-page.footer.legal-section.link-1")} ariaLabel="/general-conditions" href="/general-conditions" />
                            <FooterLink title={t("home-page.footer.legal-section.link-3")} ariaLabel="/legal-mentions" href="/legal-mentions" />
                            <FooterLink title={t("home-page.footer.legal-section.link-6")} ariaLabel="/politique-confidentialite" href="/politique-confidentialite" />
                            {/* <FooterLink title={t("home-page.footer.legal-section.link-5")} href="/warning" /> */}
                            <FooterLink title={t("home-page.footer.legal-section.link-4")} ariaLabel="/cookies" href="/cookies" />
                            <FooterLink title={t("home-page.footer.legal-section.link-2")} ariaLabel="/lexical" href="/lexical" />
                        </FooterSection>
                    </div>

                </div>

            </div>

            <FooterBottomLinks className={clx(style.footer_no_bg)} />

        </div>

    )
} 

export const FooterBottomLinks = ({ className = clx(style._footer_main_colored , style.basic_footer) }) => {
    const { t } = useTranslation("translations")

    const openCookiePreferences = (e) => {
        e.preventDefault()

        if (typeof window !== "undefined" && typeof window.displayPreferenceModal === "function") {
            window.displayPreferenceModal()
            return
        }

        const termlyBtn = document.querySelector(".termly-display-preferences")
        if (termlyBtn && typeof termlyBtn.click === "function") {
            termlyBtn.click()
        }
    }

    const linkTerms = {
        color: "#fff",
        // paddingLeft: 10  className
    }
    // clx(style._footer_main_colored, style.basic_footer)
    return (
        <div className={className}>
            <div className={style.container}>
                <div className={clx(style._copywrite_section, "py-0.5 mt-0")}> 
                    <p><span className={clx(style.__text)}>Copyright © 2018-{currentYear} Izichange. All Rights Reserved <b style={{padding:10}}></b> | <b style={{padding:10}}></b> <Link to="/general-conditions" aria-label="/general-conditions" style={linkTerms}>CGU</Link> <b style={{padding:10}}>-</b> <Link to="/politique-confidentialite" aria-label="/politique-confidentialite"  style={linkTerms}>{t("home-page.footer.legal-section.link-6")}</Link> <b style={{padding:10}}>-</b> <a href="#" aria-label="preferences-cookies" className="termly-display-preferences" onClick={openCookiePreferences} style={linkTerms}>Preferences cookies</a></span></p>
                    <div className={clx(style.flex, style.align_items_center)}>
                        <p style={{ marginRight: "1rem" }}><span className={clx(style.__text)}>{t("home-page.footer.social-media-section.title")}</span></p>
                        <FooterLink
                            target="_blank"
                            href="https://twitter.com/IZIchange"
                            ariaLabel="compte twitter izichange"
                            icon={
                                <img src="/images/twitter.png" width="13" height="13" alt="twitter"/>
                            }
                        />
                        <FooterLink
                            target="_blank"
                            href="https://web.facebook.com/izichangeofficiel"
                            ariaLabel="compte facebook izichange"
                            icon={
                                <svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.5 32.2379C8.34723 32.2379 1.7381 25.4156 1.7381 16.9998C1.7381 8.58405 8.34723 1.76172 16.5 1.76172C24.6528 1.76172 31.2619 8.58405 31.2619 16.9998C31.2619 25.4156 24.6528 32.2379 16.5 32.2379ZM16.5 32.2379V13.9522C16.5 12.269 17.8218 10.9046 19.4524 10.9046H21.6667M11.3333 20.0474H21.6667" stroke="#CBC8C8" strokeWidth="3" />
                                </svg>


                            }
                        />
                        <FooterLink
                            target="_blank"
                            href="https://www.instagram.com/izichange_/"
                            ariaLabel="Instagram izichange link"
                            icon={
                                <svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.6191 9.38077H26.0952M7.64286 1.76172H25.3571C28.6183 1.76172 31.2619 4.49065 31.2619 7.85696V26.1427C31.2619 29.509 28.6183 32.2379 25.3571 32.2379H7.64286C4.38175 32.2379 1.7381 29.509 1.7381 26.1427V7.85696C1.7381 4.49065 4.38175 1.76172 7.64286 1.76172ZM16.5 23.0951C13.2389 23.0951 10.5952 20.3661 10.5952 16.9998C10.5952 13.6335 13.2389 10.9046 16.5 10.9046C19.7611 10.9046 22.4048 13.6335 22.4048 16.9998C22.4048 20.3661 19.7611 23.0951 16.5 23.0951Z" stroke="#CBC8C8" strokeWidth="3" />
                                </svg>

                            }
                        />

                        <FooterLink
                            target="_blank"
                            href="https://www.youtube.com/@IZICHANGE"
                            ariaLabel="youtube izichange compte"
                            icon={
                                <svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.14668 30.4829L4.8531 31.9539H4.8531L5.14668 30.4829ZM35.8533 30.4829L36.1469 31.9539H36.1469L35.8533 30.4829ZM36.0641 3.6454L36.3778 2.17856L36.0641 3.6454ZM4.93587 3.6454L5.24953 5.11224H5.24953L4.93587 3.6454ZM16.8 11.3939L17.5705 10.1069C17.1071 9.82944 16.5303 9.82256 16.0603 10.0889C15.5904 10.3553 15.3 10.8537 15.3 11.3939H16.8ZM16.8 22.4705H15.3C15.3 23.0107 15.5904 23.5091 16.0603 23.7755C16.5303 24.0418 17.1071 24.0349 17.5705 23.7575L16.8 22.4705ZM26.05 16.9322L26.8205 18.2191C27.273 17.9482 27.55 17.4596 27.55 16.9322C27.55 16.4048 27.273 15.9162 26.8205 15.6452L26.05 16.9322ZM0.5 7.26938V26.6527H3.5V7.26938H0.5ZM40.5 26.6527V7.26938H37.5V26.6527H40.5ZM4.8531 31.9539C15.1821 34.0154 25.8179 34.0154 36.1469 31.9539L35.5597 29.0119C25.6184 30.996 15.3816 30.996 5.44026 29.0119L4.8531 31.9539ZM36.3778 2.17856C25.9114 -0.0595195 15.0886 -0.0595198 4.62221 2.17856L5.24953 5.11224C15.3024 2.96259 25.6976 2.96259 35.7505 5.11224L36.3778 2.17856ZM40.5 7.26938C40.5 4.8121 38.7801 2.69225 36.3778 2.17856L35.7505 5.11224C36.7731 5.3309 37.5 6.23139 37.5 7.26938H40.5ZM37.5 26.6527C37.5 27.7972 36.6901 28.7863 35.5597 29.0119L36.1469 31.9539C38.6759 31.4492 40.5 29.232 40.5 26.6527H37.5ZM0.5 26.6527C0.5 29.232 2.32414 31.4492 4.8531 31.9539L5.44026 29.0119C4.3099 28.7863 3.5 27.7972 3.5 26.6527H0.5ZM3.5 7.26938C3.5 6.23139 4.22693 5.3309 5.24953 5.11224L4.62221 2.17856C2.2199 2.69225 0.5 4.8121 0.5 7.26938H3.5ZM15.3 11.3939V22.4705H18.3V11.3939H15.3ZM17.5705 23.7575L26.8205 18.2191L25.2795 15.6452L16.0295 21.1835L17.5705 23.7575ZM26.8205 15.6452L17.5705 10.1069L16.0295 12.6808L25.2795 18.2191L26.8205 15.6452Z" fill="#CBC8C8" />
                                </svg>


                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}